module.exports = __webpack_public_path__ + "static/img/Noah-Chamberlain.253f917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Noah-Chamberlain.jpg
// module id = 2cTE
// module chunks = 0